// extracted by mini-css-extract-plugin
module.exports = {"input":"text_input__qPsVg","input_cmp_form":"text_input_cmp_form__GcaMF"};